import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisaLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 24,
	viewBox: "0 0 34 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 33,
		height: 23,
		rx: 3.5,
		fill: "white",
		stroke: "#D6D8DC"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.7501 15.8579H8.69031L7.14576 9.79198C7.07245 9.51295 6.91679 9.26627 6.68782 9.15001C6.11639 8.85784 5.48672 8.62531 4.7998 8.50804V8.2745H8.11789C8.57583 8.2745 8.91929 8.62531 8.97653 9.03274L9.77793 13.4083L11.8367 8.2745H13.8392L10.7501 15.8579ZM14.984 15.8579H13.0388L14.6406 8.2745H16.5858L14.984 15.8579ZM19.1025 10.3753C19.1597 9.96689 19.5032 9.73335 19.9039 9.73335C20.5336 9.67471 21.2195 9.79199 21.7919 10.0832L22.1354 8.45042C21.5629 8.21688 20.9333 8.09961 20.3619 8.09961C18.4738 8.09961 17.1 9.15002 17.1 10.6078C17.1 11.7169 18.0731 12.2992 18.7601 12.65C19.5032 12.9998 19.7894 13.2334 19.7322 13.5832C19.7322 14.1079 19.1597 14.3414 18.5883 14.3414C17.9014 14.3414 17.2145 14.1665 16.5858 13.8743L16.2424 15.5081C16.9293 15.7992 17.6724 15.9165 18.3594 15.9165C20.4763 15.9741 21.7919 14.9247 21.7919 13.3496C21.7919 11.3661 19.1025 11.2498 19.1025 10.3753ZM28.5998 15.8579L27.0553 8.2745H25.3962C25.0528 8.2745 24.7093 8.50804 24.5948 8.85784L21.7347 15.8579H23.7372L24.1369 14.7498H26.5973L26.8263 15.8579H28.5998ZM25.6824 10.3167L26.2539 13.1747H24.6521L25.6824 10.3167Z",
		fill: "#172B85"
	})]
});
export default SvgVisaLogo;
